/// <reference path="../../types/notifications.d.ts" />
import { useTransition, animated } from '@react-spring/web';
import NotificationElement from './NotificationElement';
import useNotificationState from './useNotificationState';

const NotificationManager = () => {
    if (!window.notifications) {
        throw new Error('Notification global variable is not initialized');
    }

    const [state, dispatch] = useNotificationState();

    // update the singletone variables
    window.notifications.dispatch = dispatch;
    window.notifications.latestState = state;

    const transitions = useTransition(state.notifications, {
        keys: item => item.id,
        from: { opacity: 0, transform: 'translate(100%,0)' },
        enter: { opacity: 1, transform: 'translate(0%,0)' },
        leave: { opacity: 0, transform: 'translate(100%,0)' },
        config: { duration: 500 },
    });

    return (
        <div
            // aria-live="assertive"
            className="flex w-full flex-col items-center space-y-4 sm:items-end"
        >
            {transitions((style, item) => (
                <animated.div className="w-full max-w-sm" style={style}>
                    <NotificationElement dispatch={dispatch} notification={item} />
                </animated.div>
            ))}
        </div>
    );
};

export default NotificationManager;
